import { isDemoMode } from '../demo/core';

/** Fetch a remote image as a data URL for html2canvas / jsPDF rasterization. */
export async function fetchImageAsDataUrl(url: string): Promise<string | null> {
  // The demo makes no network calls: inline images pass through, remote ones are skipped.
  if (isDemoMode()) {
    return url.startsWith('data:') ? url : null;
  }
  try {
    const resp = await fetch(url, { mode: 'cors' });
    if (!resp.ok) return null;
    const blob = await resp.blob();
    return await new Promise<string | null>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(typeof reader.result === 'string' ? reader.result : null);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}
